import { updateExchangesEnabled } from '../page';

export const RECEIVE_RETAILER_SETTINGS = 'RECEIVE_RETAILER_SETTINGS';
export const SET_DISPLAY_RETURN_METHOD = 'SET_DISPLAY_RETURN_METHOD';
export const SET_REQUIRED_CONDITIONS = 'SET_REQUIRED_CONDITIONS';

export const receiveRetailerSettings = (retailerSettings) => (dispatch) => {
  // TODO: Use feature flag instead of array of product strings
  const { name: retailerName, products = [] } = retailerSettings;

  dispatch(updateExchangesEnabled(products.indexOf('exchange') > -1));

  dispatch({
    type: RECEIVE_RETAILER_SETTINGS,
    data: {
      retailerSettings: {
        ...retailerSettings,
        name: retailerName.toLowerCase(),
      },
    },
  });
};

export const setDisplayReturnMethod = (displayReturnMethod) => ({
  type: SET_DISPLAY_RETURN_METHOD,
  data: { displayReturnMethod },
});

export const setRequiredConditions = (requiredConditions) => ({
  type: SET_REQUIRED_CONDITIONS,
  data: { requiredConditions },
});
